import { initAllSliders } from './shared/slider-init';

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
	initAllSliders();
});

// Also initialize when blocks are re-rendered (e.g. in FSE or some plugins)
if (window.wp && window.wp.domReady) {
	window.wp.domReady(() => {
		initAllSliders();
	});
}
